/**
 * Retourne vrai si le filtre est un filtre additionnel.
 */
const roomIsAdditionalFilter = (filter) =>
  [
    "isBookableFront",
    "epi",
    "pros",
    "comment",
    "pets",
    "reference",
    "beds",
    "chambers",
    "nature",
  ].includes(filter) || /feature/.test(filter);

export default roomIsAdditionalFilter;
